export default "__VITE_ASSET__5d054aa2__"